{
	"ariaDecreaseGridThumbnailSize": "Decrease Grid Thumbnail Size",
	"ariaGridSize": "Grid Size",
	"ariaIncreaseGridThumbnailSize": "Increase Grid Thumbnail Size"
}
